/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Stage environment overrides.
 */

const stg = {
  BERLIN_ENV: 'stage',
  INT_LOGIN_URL: 'https://mycloud.pearson.com/redirect',
  INT_LOGOUT_URL: 'https://mycloud.pearson.com/logout',
  DELAYED_GTM: false,
  GTM_CONTAINER_ID: 'GTM-WTX7GQN',
  GTM_AUTH: '2RfxHnUh9vgQxsMrRfX-zQ',
  GTM_PREVIEW: 'env-5',
  INT_AZURE_CLIENT_ID: '80e606ce-e3e0-4db3-9602-ee8e8117064a',
  AZURE_TENANT_ID: '209a71f6-c9bb-48f1-a23d-a26d275b75e2',
  AZURE_REDIRECT_URI: 'https://evergreen-stg.pearson.com/',
  BERLIN_API_URI: 'https://berlin-api-pplus.etext-stg.pearsondev.tech',
  EVG_SVC_URL: 'https://evergreen-svc.stg-prsn.com',
  AI_ADMIN_SERVICES: 'https://aiadmin-api-pplus.etext-stg.pearsondev.tech',
  AI_ADMIN_URL: 'https://aiadmin-stg.pearson.com',
  PXE_READER_URL: 'https://plus-stg.pearson.com/eps/pearson-reader/api/item/pxe'
};

export default stg;
